var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"no-auth"},[_c('Error',{staticStyle:{"margin":"0 auto"},attrs:{"reload":true,"title":_vm.$t('com_error_network'),"description":_vm.$t('com_error_network_description'),"inline":true,"homeClick":() => {
        this.$router.push({ name: 'Home' });
      }}},[_c('Icon',{attrs:{"type":"networkerror2"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }